export const countries = [
  {
    key: 'ES',
    text: 'España',
    value: 'ES',
  },
  {
    key: 'AF',
    text: 'Afganistán',
    value: 'AF',
  },
  {
    key: 'AX',
    text: 'Åland',
    value: 'AX',
  },
  {
    key: 'AL',
    text: 'Albania',
    value: 'AL',
  },
  {
    key: 'DE',
    text: 'Alemania',
    value: 'DE',
  },
  {
    key: 'AD',
    text: 'Andorra',
    value: 'AD',
  },
  {
    key: 'AO',
    text: 'Angola',
    value: 'AO',
  },
  {
    key: 'AI',
    text: 'Anguila',
    value: 'AI',
  },
  {
    key: 'AQ',
    text: 'Antártida',
    value: 'AQ',
  },
  {
    key: 'AG',
    text: 'Antigua y Barbuda',
    value: 'AG',
  },
  {
    key: 'SA',
    text: 'Arabia Saudita',
    value: 'SA',
  },
  {
    key: 'DZ',
    text: 'Argelia',
    value: 'DZ',
  },
  {
    key: 'AR',
    text: 'Argentina',
    value: 'AR',
  },
  {
    key: 'AM',
    text: 'Armenia',
    value: 'AM',
  },
  {
    key: 'AW',
    text: 'Aruba',
    value: 'AW',
  },
  {
    key: 'AU',
    text: 'Australia',
    value: 'AU',
  },
  {
    key: 'AT',
    text: 'Austria',
    value: 'AT',
  },
  {
    key: 'AZ',
    text: 'Azerbaiyán',
    value: 'AZ',
  },
  {
    key: 'BS',
    text: 'Bahamas',
    value: 'BS',
  },
  {
    key: 'BD',
    text: 'Bangladés',
    value: 'BD',
  },
  {
    key: 'BB',
    text: 'Barbados',
    value: 'BB',
  },
  {
    key: 'BH',
    text: 'Baréin',
    value: 'BH',
  },
  {
    key: 'BE',
    text: 'Bélgica',
    value: 'BE',
  },
  {
    key: 'BZ',
    text: 'Belice',
    value: 'BZ',
  },
  {
    key: 'BJ',
    text: 'Benín',
    value: 'BJ',
  },
  {
    key: 'BM',
    text: 'Bermudas',
    value: 'BM',
  },
  {
    key: 'BY',
    text: 'Bielorrusia',
    value: 'BY',
  },
  {
    key: 'BO',
    text: 'Bolivia',
    value: 'BO',
  },
  {
    key: 'BQ',
    text: 'Bonaire, San Eustaquio y Saba',
    value: 'BQ',
  },
  {
    key: 'BA',
    text: 'Bosnia y Herzegovina',
    value: 'BA',
  },
  {
    key: 'BW',
    text: 'Botsuana',
    value: 'BW',
  },
  {
    key: 'BR',
    text: 'Brasil',
    value: 'BR',
  },
  {
    key: 'BN',
    text: 'Brunéi',
    value: 'BN',
  },
  {
    key: 'BG',
    text: 'Bulgaria',
    value: 'BG',
  },
  {
    key: 'BF',
    text: 'Burkina Faso',
    value: 'BF',
  },
  {
    key: 'BI',
    text: 'Burundi',
    value: 'BI',
  },
  {
    key: 'BT',
    text: 'Bután',
    value: 'BT',
  },
  {
    key: 'CV',
    text: 'Cabo Verde',
    value: 'CV',
  },
  {
    key: 'KH',
    text: 'Camboya',
    value: 'KH',
  },
  {
    key: 'CM',
    text: 'Camerún',
    value: 'CM',
  },
  {
    key: 'CA',
    text: 'Canadá',
    value: 'CA',
  },
  {
    key: 'QA',
    text: 'Catar',
    value: 'QA',
  },
  {
    key: 'TD',
    text: 'Chad',
    value: 'TD',
  },
  {
    key: 'CL',
    text: 'Chile',
    value: 'CL',
  },
  {
    key: 'CN',
    text: 'China',
    value: 'CN',
  },
  {
    key: 'CY',
    text: 'Chipre',
    value: 'CY',
  },
  {
    key: 'CO',
    text: 'Colombia',
    value: 'CO',
  },
  {
    key: 'KM',
    text: 'Comoras',
    value: 'KM',
  },
  {
    key: 'KP',
    text: 'Corea del Norte',
    value: 'KP',
  },
  {
    key: 'KR',
    text: 'Corea del Sur',
    value: 'KR',
  },
  {
    key: 'CI',
    text: 'Costa de Marfil',
    value: 'CI',
  },
  {
    key: 'CR',
    text: 'Costa Rica',
    value: 'CR',
  },
  {
    key: 'HR',
    text: 'Croacia',
    value: 'HR',
  },
  {
    key: 'CU',
    text: 'Cuba',
    value: 'CU',
  },
  {
    key: 'CW',
    text: 'Curazao',
    value: 'CW',
  },
  {
    key: 'DK',
    text: 'Dinamarca',
    value: 'DK',
  },
  {
    key: 'DM',
    text: 'Dominica',
    value: 'DM',
  },
  {
    key: 'EC',
    text: 'Ecuador',
    value: 'EC',
  },
  {
    key: 'EG',
    text: 'Egipto',
    value: 'EG',
  },
  {
    key: 'SV',
    text: 'El Salvador',
    value: 'SV',
  },
  {
    key: 'AE',
    text: 'Emiratos Árabes Unidos',
    value: 'AE',
  },
  {
    key: 'ER',
    text: 'Eritrea',
    value: 'ER',
  },
  {
    key: 'SK',
    text: 'Eslovaquia',
    value: 'SK',
  },
  {
    key: 'SI',
    text: 'Eslovenia',
    value: 'SI',
  },
  {
    key: 'US',
    text: 'Estados Unidos',
    value: 'US',
  },
  {
    key: 'EE',
    text: 'Estonia',
    value: 'EE',
  },
  {
    key: 'ET',
    text: 'Etiopía',
    value: 'ET',
  },
  {
    key: 'PH',
    text: 'Filipinas',
    value: 'PH',
  },
  {
    key: 'FI',
    text: 'Finlandia',
    value: 'FI',
  },
  {
    key: 'FJ',
    text: 'Fiyi',
    value: 'FJ',
  },
  {
    key: 'FR',
    text: 'Francia',
    value: 'FR',
  },
  {
    key: 'GA',
    text: 'Gabón',
    value: 'GA',
  },
  {
    key: 'GM',
    text: 'Gambia',
    value: 'GM',
  },
  {
    key: 'GE',
    text: 'Georgia',
    value: 'GE',
  },
  {
    key: 'GH',
    text: 'Ghana',
    value: 'GH',
  },
  {
    key: 'GI',
    text: 'Gibraltar',
    value: 'GI',
  },
  {
    key: 'GD',
    text: 'Granada',
    value: 'GD',
  },
  {
    key: 'GR',
    text: 'Grecia',
    value: 'GR',
  },
  {
    key: 'GL',
    text: 'Groenlandia',
    value: 'GL',
  },
  {
    key: 'GP',
    text: 'Guadalupe',
    value: 'GP',
  },
  {
    key: 'GU',
    text: 'Guam',
    value: 'GU',
  },
  {
    key: 'GT',
    text: 'Guatemala',
    value: 'GT',
  },
  {
    key: 'GF',
    text: 'Guayana Francesa',
    value: 'GF',
  },
  {
    key: 'GG',
    text: 'Guernsey',
    value: 'GG',
  },
  {
    key: 'GN',
    text: 'Guinea',
    value: 'GN',
  },
  {
    key: 'GW',
    text: 'Guinea-Bisáu',
    value: 'GW',
  },
  {
    key: 'GQ',
    text: 'Guinea Ecuatorial',
    value: 'GQ',
  },
  {
    key: 'GY',
    text: 'Guyana',
    value: 'GY',
  },
  {
    key: 'HT',
    text: 'Haití',
    value: 'HT',
  },
  {
    key: 'HN',
    text: 'Honduras',
    value: 'HN',
  },
  {
    key: 'HK',
    text: 'Hong Kong',
    value: 'HK',
  },
  {
    key: 'HU',
    text: 'Hungría',
    value: 'HU',
  },
  {
    key: 'IN',
    text: 'India',
    value: 'IN',
  },
  {
    key: 'ID',
    text: 'Indonesia',
    value: 'ID',
  },
  {
    key: 'IQ',
    text: 'Irak',
    value: 'IQ',
  },
  {
    key: 'IR',
    text: 'Irán',
    value: 'IR',
  },
  {
    key: 'IE',
    text: 'Irlanda',
    value: 'IE',
  },
  {
    key: 'BV',
    text: 'Isla Bouvet',
    value: 'BV',
  },
  {
    key: 'IM',
    text: 'Isla de Man',
    value: 'IM',
  },
  {
    key: 'CX',
    text: 'Isla de Navidad',
    value: 'CX',
  },
  {
    key: 'IS',
    text: 'Islandia',
    value: 'IS',
  },
  {
    key: 'KY',
    text: 'Islas Caimán',
    value: 'KY',
  },
  {
    key: 'CC',
    text: 'Islas Cocos',
    value: 'CC',
  },
  {
    key: 'CK',
    text: 'Islas Cook',
    value: 'CK',
  },
  {
    key: 'FO',
    text: 'Islas Feroe',
    value: 'FO',
  },
  {
    key: 'GS',
    text: 'Islas Georgias del Sur y Sandwich del Sur',
    value: 'GS',
  },
  {
    key: 'HM',
    text: 'Islas Heard y McDonald',
    value: 'HM',
  },
  {
    key: 'FK',
    text: 'Islas Malvinas',
    value: 'FK',
  },
  {
    key: 'MP',
    text: 'Islas Marianas del Norte',
    value: 'MP',
  },
  {
    key: 'MH',
    text: 'Islas Marshall',
    value: 'MH',
  },
  {
    key: 'PN',
    text: 'Islas Pitcairn',
    value: 'PN',
  },
  {
    key: 'SB',
    text: 'Islas Salomón',
    value: 'SB',
  },
  {
    key: 'TC',
    text: 'Islas Turcas y Caicos',
    value: 'TC',
  },
  {
    key: 'UM',
    text: 'Islas Ultramarinas Menores de los Estados Unidos',
    value: 'UM',
  },
  {
    key: 'VG',
    text: 'Islas Vírgenes Británicas',
    value: 'VG',
  },
  {
    key: 'VI',
    text: 'Islas Vírgenes de los Estados Unidos',
    value: 'VI',
  },
  {
    key: 'IL',
    text: 'Israel',
    value: 'IL',
  },
  {
    key: 'IT',
    text: 'Italia',
    value: 'IT',
  },
  {
    key: 'JM',
    text: 'Jamaica',
    value: 'JM',
  },
  {
    key: 'JP',
    text: 'Japón',
    value: 'JP',
  },
  {
    key: 'JE',
    text: 'Jersey',
    value: 'JE',
  },
  {
    key: 'JO',
    text: 'Jordania',
    value: 'JO',
  },
  {
    key: 'KZ',
    text: 'Kazajistán',
    value: 'KZ',
  },
  {
    key: 'KE',
    text: 'Kenia',
    value: 'KE',
  },
  {
    key: 'KG',
    text: 'Kirguistán',
    value: 'KG',
  },
  {
    key: 'KI',
    text: 'Kiribati',
    value: 'KI',
  },
  {
    key: 'KW',
    text: 'Kuwait',
    value: 'KW',
  },
  {
    key: 'LA',
    text: 'Laos',
    value: 'LA',
  },
  {
    key: 'LS',
    text: 'Lesoto',
    value: 'LS',
  },
  {
    key: 'LV',
    text: 'Letonia',
    value: 'LV',
  },
  {
    key: 'LB',
    text: 'Líbano',
    value: 'LB',
  },
  {
    key: 'LR',
    text: 'Liberia',
    value: 'LR',
  },
  {
    key: 'LY',
    text: 'Libia',
    value: 'LY',
  },
  {
    key: 'LI',
    text: 'Liechtenstein',
    value: 'LI',
  },
  {
    key: 'LT',
    text: 'Lituania',
    value: 'LT',
  },
  {
    key: 'LU',
    text: 'Luxemburgo',
    value: 'LU',
  },
  {
    key: 'MO',
    text: 'Macao',
    value: 'MO',
  },
  {
    key: 'MK',
    text: 'Macedonia del Norte',
    value: 'MK',
  },
  {
    key: 'MG',
    text: 'Madagascar',
    value: 'MG',
  },
  {
    key: 'MY',
    text: 'Malasia',
    value: 'MY',
  },
  {
    key: 'MW',
    text: 'Malaui',
    value: 'MW',
  },
  {
    key: 'MV',
    text: 'Maldivas',
    value: 'MV',
  },
  {
    key: 'ML',
    text: 'Malí',
    value: 'ML',
  },
  {
    key: 'MT',
    text: 'Malta',
    value: 'MT',
  },
  {
    key: 'MA',
    text: 'Marruecos',
    value: 'MA',
  },
  {
    key: 'MQ',
    text: 'Martinica',
    value: 'MQ',
  },
  {
    key: 'MU',
    text: 'Mauricio',
    value: 'MU',
  },
  {
    key: 'MR',
    text: 'Mauritania',
    value: 'MR',
  },
  {
    key: 'YT',
    text: 'Mayotte',
    value: 'YT',
  },
  {
    key: 'MX',
    text: 'México',
    value: 'MX',
  },
  {
    key: 'FM',
    text: 'Micronesia',
    value: 'FM',
  },
  {
    key: 'MD',
    text: 'Moldavia',
    value: 'MD',
  },
  {
    key: 'MC',
    text: 'Mónaco',
    value: 'MC',
  },
  {
    key: 'MN',
    text: 'Mongolia',
    value: 'MN',
  },
  {
    key: 'ME',
    text: 'Montenegro',
    value: 'ME',
  },
  {
    key: 'MS',
    text: 'Montserrat',
    value: 'MS',
  },
  {
    key: 'MZ',
    text: 'Mozambique',
    value: 'MZ',
  },
  {
    key: 'MM',
    text: 'Birmania',
    value: 'MM',
  },
  {
    key: 'NA',
    text: 'Namibia',
    value: 'NA',
  },
  {
    key: 'NR',
    text: 'Nauru',
    value: 'NR',
  },
  {
    key: 'NP',
    text: 'Nepal',
    value: 'NP',
  },
  {
    key: 'NI',
    text: 'Nicaragua',
    value: 'NI',
  },
  {
    key: 'NE',
    text: 'Níger',
    value: 'NE',
  },
  {
    key: 'NG',
    text: 'Nigeria',
    value: 'NG',
  },
  {
    key: 'NU',
    text: 'Niue',
    value: 'NU',
  },
  {
    key: 'NF',
    text: 'Isla Norfolk',
    value: 'NF',
  },
  {
    key: 'NO',
    text: 'Noruega',
    value: 'NO',
  },
  {
    key: 'NC',
    text: 'Nueva Caledonia',
    value: 'NC',
  },
  {
    key: 'NZ',
    text: 'Nueva Zelanda',
    value: 'NZ',
  },
  {
    key: 'OM',
    text: 'Omán',
    value: 'OM',
  },
  {
    key: 'NL',
    text: 'Países Bajos',
    value: 'NL',
  },
  {
    key: 'PK',
    text: 'Pakistán',
    value: 'PK',
  },
  {
    key: 'PW',
    text: 'Palaos',
    value: 'PW',
  },
  {
    key: 'PS',
    text: 'Palestina',
    value: 'PS',
  },
  {
    key: 'PA',
    text: 'Panamá',
    value: 'PA',
  },
  {
    key: 'PG',
    text: 'Papúa Nueva Guinea',
    value: 'PG',
  },
  {
    key: 'PY',
    text: 'Paraguay',
    value: 'PY',
  },
  {
    key: 'PE',
    text: 'Perú',
    value: 'PE',
  },
  {
    key: 'PF',
    text: 'Polinesia Francesa',
    value: 'PF',
  },
  {
    key: 'PL',
    text: 'Polonia',
    value: 'PL',
  },
  {
    key: 'PT',
    text: 'Portugal',
    value: 'PT',
  },
  {
    key: 'PR',
    text: 'Puerto Rico',
    value: 'PR',
  },
  {
    key: 'GB',
    text: 'Reino Unido',
    value: 'GB',
  },
  {
    key: 'EH',
    text: 'República Árabe Saharaui Democrática',
    value: 'EH',
  },
  {
    key: 'CF',
    text: 'República Centroafricana',
    value: 'CF',
  },
  {
    key: 'CZ',
    text: 'República Checa',
    value: 'CZ',
  },
  {
    key: 'CG',
    text: 'República del Congo',
    value: 'CG',
  },
  {
    key: 'CD',
    text: 'República Democrática del Congo',
    value: 'CD',
  },
  {
    key: 'DO',
    text: 'República Dominicana',
    value: 'DO',
  },
  {
    key: 'RE',
    text: 'Reunión',
    value: 'RE',
  },
  {
    key: 'RW',
    text: 'Ruanda',
    value: 'RW',
  },
  {
    key: 'RO',
    text: 'Rumania',
    value: 'RO',
  },
  {
    key: 'RU',
    text: 'Rusia',
    value: 'RU',
  },
  {
    key: 'WS',
    text: 'Samoa',
    value: 'WS',
  },
  {
    key: 'AS',
    text: 'Samoa Americana',
    value: 'AS',
  },
  {
    key: 'BL',
    text: 'San Bartolomé',
    value: 'BL',
  },
  {
    key: 'KN',
    text: 'San Cristóbal y Nieves',
    value: 'KN',
  },
  {
    key: 'SM',
    text: 'San Marino',
    value: 'SM',
  },
  {
    key: 'MF',
    text: 'San Martín',
    value: 'MF',
  },
  {
    key: 'PM',
    text: 'San Pedro y Miquelón',
    value: 'PM',
  },
  {
    key: 'VC',
    text: 'San Vicente y las Granadinas',
    value: 'VC',
  },
  {
    key: 'SH',
    text: 'Santa Elena, Ascensión y Tristán de Acuña',
    value: 'SH',
  },
  {
    key: 'LC',
    text: 'Santa Lucía',
    value: 'LC',
  },
  {
    key: 'ST',
    text: 'Santo Tomé y Príncipe',
    value: 'ST',
  },
  {
    key: 'SN',
    text: 'Senegal',
    value: 'SN',
  },
  {
    key: 'RS',
    text: 'Serbia',
    value: 'RS',
  },
  {
    key: 'SC',
    text: 'Seychelles',
    value: 'SC',
  },
  {
    key: 'SL',
    text: 'Sierra Leona',
    value: 'SL',
  },
  {
    key: 'SG',
    text: 'Singapur',
    value: 'SG',
  },
  {
    key: 'SX',
    text: 'San Martín',
    value: 'SX',
  },
  {
    key: 'SY',
    text: 'Siria',
    value: 'SY',
  },
  {
    key: 'SO',
    text: 'Somalia',
    value: 'SO',
  },
  {
    key: 'LK',
    text: 'Sri Lanka',
    value: 'LK',
  },
  {
    key: 'SZ',
    text: 'Suazilandia',
    value: 'SZ',
  },
  {
    key: 'ZA',
    text: 'Sudáfrica',
    value: 'ZA',
  },
  {
    key: 'SD',
    text: 'Sudán',
    value: 'SD',
  },
  {
    key: 'SS',
    text: 'Sudán del Sur',
    value: 'SS',
  },
  {
    key: 'SE',
    text: 'Suecia',
    value: 'SE',
  },
  {
    key: 'CH',
    text: 'Suiza',
    value: 'CH',
  },
  {
    key: 'SR',
    text: 'Surinam',
    value: 'SR',
  },
  {
    key: 'SJ',
    text: 'Svalbard y Jan Mayen',
    value: 'SJ',
  },
  {
    key: 'TH',
    text: 'Tailandia',
    value: 'TH',
  },
  {
    key: 'TW',
    text: 'Taiwán (República de China)',
    value: 'TW',
  },
  {
    key: 'TZ',
    text: 'Tanzania',
    value: 'TZ',
  },
  {
    key: 'TJ',
    text: 'Tayikistán',
    value: 'TJ',
  },
  {
    key: 'IO',
    text: 'Territorio Británico del Océano Índico',
    value: 'IO',
  },
  {
    key: 'TF',
    text: 'Tierras Australes y Antárticas Francesas',
    value: 'TF',
  },
  {
    key: 'TL',
    text: 'Timor Oriental',
    value: 'TL',
  },
  {
    key: 'TG',
    text: 'Togo',
    value: 'TG',
  },
  {
    key: 'TK',
    text: 'Tokelau',
    value: 'TK',
  },
  {
    key: 'TO',
    text: 'Tonga',
    value: 'TO',
  },
  {
    key: 'TT',
    text: 'Trinidad y Tobago',
    value: 'TT',
  },
  {
    key: 'TN',
    text: 'Túnez',
    value: 'TN',
  },
  {
    key: 'TM',
    text: 'Turkmenistán',
    value: 'TM',
  },
  {
    key: 'TR',
    text: 'Turquía',
    value: 'TR',
  },
  {
    key: 'TV',
    text: 'Tuvalu',
    value: 'TV',
  },
  {
    key: 'UA',
    text: 'Ucrania',
    value: 'UA',
  },
  {
    key: 'UG',
    text: 'Uganda',
    value: 'UG',
  },
  {
    key: 'UY',
    text: 'Uruguay',
    value: 'UY',
  },
  {
    key: 'UZ',
    text: 'Uzbekistán',
    value: 'UZ',
  },
  {
    key: 'VU',
    text: 'Vanuatu',
    value: 'VU',
  },
  {
    key: 'VA',
    text: 'Ciudad del Vaticano',
    value: 'VA',
  },
  {
    key: 'VE',
    text: 'Venezuela',
    value: 'VE',
  },
  {
    key: 'VN',
    text: 'Vietnam',
    value: 'VN',
  },
  {
    key: 'WF',
    text: 'Wallis y Futuna',
    value: 'WF',
  },
  {
    key: 'YE',
    text: 'Yemen',
    value: 'YE',
  },
  {
    key: 'DJ',
    text: 'Yibuti',
    value: 'DJ',
  },
  {
    key: 'ZM',
    text: 'Zambia',
    value: 'ZM',
  },
  {
    key: 'ZW',
    text: 'Zimbabue',
    value: 'ZW',
  },
];
